import { MainCategoryResult } from "@/schema/assessment-results/MainCategoryResult";
import AssessmentGroupList from "@/src/_components/AssessmentResult/AssessmentGroupList";
import { useTranslation } from "react-i18next";

interface AssessmentDetailProps {
  mainCategoryResults: MainCategoryResult[];
}
export default function AssessmentDetails({
  mainCategoryResults,
}: AssessmentDetailProps) {
  const { t } = useTranslation();

  return (
    <div
      className="flex flex-col rounded-[12px]
     shadow-[0px_0px_0px_1px_#00000006,_1px_2px_4px_0px_#00000014]"
    >
      {mainCategoryResults.map((data, index) => {
        if (index == 0) {
          return (
            <div className="pdf-component" key={data.id}>
              <div className="my-[20px] mx-[24px]">
                <span className="text-cool-gray-900 text-[18px] leading-[28px]">
                  {t("assessment-details")}
                </span>
              </div>
              <AssessmentGroupList result={data} />
            </div>
          );
        }
        return (
          <div className="pdf-component" key={data.id}>
            <AssessmentGroupList result={data} />
          </div>
        );
      })}
    </div>
  );
}
